import { schema } from 'normalizr';
import { SCHEMA_TYPE_CREDENTIALS } from '../constants/schemaTypes';
import has from 'lodash/has';
import isNil from 'lodash/isNil';

import userSchema from './user';
import orgSchema from './org';
import vendorSchema from './vendor';
import * as credentialStatus from 'js/constants/credentialStatus';

const credentialSchema = new schema.Entity(
  SCHEMA_TYPE_CREDENTIALS,
  {
    owner: userSchema,
    org: orgSchema,
    vendor: vendorSchema,
  },
  {
    processStrategy: (value) => {
      let finalValue = value;
      if (has(value, 'vendor') && !isNil(value.vendor)) {
        finalValue = { ...value, vendor_id: value.vendor.id };
      }

      finalValue.validStatus = finalValue.verified_status
        ? finalValue.verified_status.startsWith('200')
          ? credentialStatus.CREDENTIAL_VALID
          : credentialStatus.CREDENTIAL_INVALID
        : credentialStatus.CREDENTIAL_UNTESTED;

      return finalValue;
    },
  },
);

export default credentialSchema;
